"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var CloseCircle = function CloseCircle() {
  return _react2.default.createElement(
    "g",
    { id: "close-circle" },
    _react2.default.createElement("path", { d: "M381.052625,327.89475 L327.368417,381.578958 L249.473667,303.684208 L171.578958,381.578958 L117.89475,327.89475 L195.789458,250 L117.89475,172.10525 L171.578958,118.421042 L249.473667,196.315792 L327.368417,118.421042 L381.052625,172.10525 L303.157875,250 L381.052625,327.89475 Z M250,0 C112.10525,0 0,112.10525 0,250 C0,387.89475 112.10525,500 250,500 C387.89475,500 500,387.89475 500,250 C500,112.10525 387.89475,0 250,0 L250,0 Z" })
  );
};

exports.default = CloseCircle;


//////////////////
// WEBPACK FOOTER
// ./~/nitro-components/build/nitro/nitro-icon/Icons/CloseCircle.js
// module id = 2937
// module chunks = 4